module.exports = __webpack_public_path__ + "media/images/flags/GD-1c0e671815b4ec6c1f2f48214cd67211.svg";